import React from 'react';
import Fonts from '../shared/theme/depricatedStyles/Fonts';

const LoggingIn = () => <div style={{ fontSize: Fonts.size.xlarge }}>Please wait......</div>;

export default LoggingIn;
